import React from 'react';
import { Buttons } from 'components/buttons/Buttons';
import { Button } from 'components/button/Button';
import { TextButton } from 'components/button/TextButton';
import { MegaButton } from 'components/button/MegaButton';
import { RichText } from 'components/rich-text/RichText';

export const ButtonsSlice = ({ title, heading, layout, items, isSlice, isArticle }) => {
  const colors = (color) => {
    switch (color) {
      case 'Brand':
        return 'brand';
      case 'White':
        return 'white';
      case 'Dark':
        return 'dark';
      default:
        return 'brand';
    }
  };

  return (
    <Buttons
      title={RichText.render(heading)}
      alignment={layout?.toLowerCase().replace(' ', '-')}
      isSlice={isSlice}
      isArticle={isArticle}
    >
      {items?.map((item, index) => {
        if (item.style === 'Basic' || item.style === null) {
          return (
            <Button key={index} link={item.link} color={colors(item.color)}>
              {item.label}
            </Button>
          );
        }
        if (item.style === 'Text') {
          return (
            <TextButton key={index} link={item.link}>
              {item.label}
            </TextButton>
          );
        }
        if (item.style === 'Extended') {
          return (
            <MegaButton
              key={index}
              link={item.link}
              // label={item.label}
              color={colors(item.color)}
              caption={item.label}
              subline={item.subline}
            >
              {/* {item.label} */}
            </MegaButton>
          );
        }
      })}
    </Buttons>
  );
};

export default ButtonsSlice;
